import {match} from 'ts-pattern';

import {TelephonyCallDetailRecord} from '@dms/api/settings';
import {businessCaseRoutes, interestRoutes, workshopRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

/** The detail page of a record a call is linked to. */
export const getCallRecordDetailPath = (record: TelephonyCallDetailRecord) =>
  match(record.resourceId)
    .with('INTEREST', () =>
      composePath(interestRoutes.detailOverview, {params: {id: record.recordId}})
    )
    .with('BUSINESS_CASE', () =>
      composePath(businessCaseRoutes.overview, {params: {id: record.recordId}})
    )
    .with('SERVICE_CASE', () =>
      composePath(workshopRoutes.serviceCaseDetail, {params: {id: record.recordId}})
    )
    .with('WORKSHOP_INTEREST', () =>
      composePath(workshopRoutes.interestDetailOverview, {params: {id: record.recordId}})
    )
    .exhaustive();
